module.exports = __webpack_public_path__ + "img/102.9eac103d.jpg";